// extracted by mini-css-extract-plugin
module.exports = {"listItem":"List_listItem__6Aud-","productImg":"List_productImg__3Uexk","title":"List_title__1iXL6","desc":"List_desc__Z3ZwF","price":"List_price__373EE"};